import { CustodianStatementLink } from "@/shared/types";
import * as RouteNames from "@/employee/route-names";

export const taxLink: CustodianStatementLink = {
  url: "/cash-account/statements",
  target: "_self"
};

export const statementsLink = taxLink;

export const footerTemplate = "AvidiaFooter";

export const investmentRiskDisclaimer = null;

export const displayMyProfileEditMode = true;

export const logoutRedirectUrl = null;

export const faqTemplate = "AvidiaForms";

export const faqLinkAddress = "";

export const displayAdvice = true;

export const displayFaqExternalLinks = true;

export const displayFaqInstructions = false;

export const displayInvestmentsSection = true;

export const displaySettingsLinkedAccounts = true;

export const contactDetailsSetAtBank = false;

export const allowEmailEdit = true;

export const priorYearContributionOption = true;

export const allowReimbursement = true;

export const showPendingReimbursements = true;

export const showAlternateOnboardingCompleteMessage = false;

export const disabledRouteRedirects = {
  [RouteNames.ContributionsEdit]: RouteNames.Contribution,
  [RouteNames.ManagePayrollContributions]: RouteNames.Contribution,
  [RouteNames.ContributionsManageOtherHsaAmounts]: RouteNames.Contribution,
  [RouteNames.ConfirmContribution]: RouteNames.Contribution
};

export const displayCashAccountMfaPopup = false;

// update the lob letter sender to use updated URL Helpers.PortalSupportConstants/AvidiaNoDisclosureUrl
export const termsUrl = "/AvidiaTerms_20240701.pdf";

export const feeTemplate = "AvidiaTermsFeeSchedule";

export const quarterlyPaperStatementFee = 2.25;

export const manageHsaCardsInPortal = true;

export const displayPriorYearContributionDisclaimerCopy = false;

export const displayProjectedContributions = true;

export const allowUserToEditContributions = true;

export const displayPdfForESign = false;

export const displayHealthcareBluebookLink = false;

export const displayFooterLegalSection = true;

export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = true;

export const disableHsaInvestEnrollButtonAfterDate = "8/15/2025";

export const disablePortalFunctionalityAfterDate = "8/30/2025";

export const displayFdicBanner = true;

export const fdicDisclaimer = "For deposit accounts at Avidia Bank";